/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface EditAcknowledgedNoteRequest
 */
export interface EditAcknowledgedNoteRequest {
  /**
   *
   * @type {string}
   * @memberof EditAcknowledgedNoteRequest
   */
  alarmId: string;
  /**
   *
   * @type {string}
   * @memberof EditAcknowledgedNoteRequest
   */
  note?: string | null;
}

/**
 * Check if a given object implements the EditAcknowledgedNoteRequest interface.
 */
export function instanceOfEditAcknowledgedNoteRequest(
  value: object,
): value is EditAcknowledgedNoteRequest {
  if (!("alarmId" in value) || value["alarmId"] === undefined) return false;
  return true;
}

export function EditAcknowledgedNoteRequestFromJSON(
  json: any,
): EditAcknowledgedNoteRequest {
  return EditAcknowledgedNoteRequestFromJSONTyped(json, false);
}

export function EditAcknowledgedNoteRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EditAcknowledgedNoteRequest {
  if (json == null) {
    return json;
  }
  return {
    alarmId: json["alarmId"],
    note: json["note"] == null ? undefined : json["note"],
  };
}

export function EditAcknowledgedNoteRequestToJSON(
  json: any,
): EditAcknowledgedNoteRequest {
  return EditAcknowledgedNoteRequestToJSONTyped(json, false);
}

export function EditAcknowledgedNoteRequestToJSONTyped(
  value?: EditAcknowledgedNoteRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    alarmId: value["alarmId"],
    note: value["note"],
  };
}
